export const enClientPortalHandoverApprovalSection = {
    title: 'Share & approve',
    olderDraftTooltip: 'A newer draft exists. Switch to the latest draft.',
    handoverInfoText: 'Your appraiser has received your comments and will provide a new draft.',
    internalApproval: {
        openApprovalDescription: 'Issue approval on behalf of the fund partner.',
        approvedInfoText: 'Final approval by the CMC is still pending.',
        sectionLabel: 'Approval by fund',
    },
    approval: {
        sectionLabel: 'Approval by CMC',
        approvedInfoText: 'Your appraiser has received your approval for finalisation and will provide the final valuation report.',
    },
}
